<template>
    <div :id="id" :year="year"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
    name: "chartMonth",
    mixins: [EmCommonApi],
    props: {
        id: String,
        year: String,
    },
    data() {
        return {
            chart: {},
            dataValueX: [],
            dataValueY: [],
            option: {},
            fresh: {},
        }
    },
    watch: {
        //监听year的变化，这个year是父组件传递的参数，利用watch监听再刷新当前子组件
        year(newValue, oldValue) {
            console.log("旧年份：" + oldValue + "父组件传递的新年份：" + newValue)
            this.getRemoteData();
        }
    },
    created() {
        //子组件自己初始化年份
        if (this.year === "") {
            this.year = new Date().getFullYear();
        }
    },
    mounted() {

        //window.addEventListener('resize', this.chart.resize, false)

        //这里可以屏蔽了，用watch生命周期监控year就可以触发了
        //this.getRemoteData();

        //定时轮巡查询
        //this.fresh = setInterval(() => {
        //   this.getRemoteData();
        //   window.addEventListener('resize', this.chart.resize, false)
        // },  10000);

    },
    beforeDestroy() {
        //clearInterval(this.fresh);
        //window.removeEventListener('resize', this.chart.resize, false)
    },
    methods: {
        getRemoteData() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("emAcctHandleRecordAhr")}/emAcctHandleRecordAhr/echart/chartMonth`
            console.log(_api)

            //注意给后端传递年份查询参数 {s_year: this.year}
            this.$_emApiMixin_post(_api, {s_year: _this.year}, false).then(value => {
                let data = value.data;
                //console.log('--------------- 按月统计 后端返回结果 ----------------')
                //console.log(data)

                let monthData = []
                let numData = []
                let f_arr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
                for (let monthStr of f_arr) {

                    let keySign = 0;
                    for (let key in data) {
                        if (monthStr === data[key].month.substring(data[key].month.length, 5)) {
                            monthData.push(monthStr + '月');
                            numData.push(data[key].num);

                            keySign = 1;
                            break;
                        }
                    }
                    if (keySign === 0) {
                        monthData.push(monthStr + '月');
                        numData.push(0);
                    }
                }

                // console.log(monthData)
                // console.log(numData)

                this.dataValueX = monthData;
                this.dataValueY = numData;

                //记得异步调用后端，要写进then里渲染
                //渲染echart
                this.loadChart()
            })


        },
        loadChart() {
            this.option = {
                title: {
                    text: this.year + '年度月份设备故障趋势统计'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['事故频次']
                },
                xAxis: {
                    data: this.dataValueX
                },
                yAxis: {},
                series: [{
                    name: '频次',
                    type: 'line',
                    data: this.dataValueY,
                }]
            }
            this.chart = echarts.init(document.getElementById(this.id));
            this.chart.setOption(this.option);

            //echart浏览器自动缩放
            let myChart = this.chart;
            window.addEventListener('resize', () => {
                myChart.resize();
            })
        }
    }
}
</script>

<style scoped>

</style>
